import React from 'react';
import classNames from 'classnames';

import ProgressBar from '../../../../design-system/ProgressBar/ProgressBar';

const StageProgress = ({
    name,
    progress,
    containerClassName = '',
    progressBarClassName = 'w-full',
    gapX = 8,
    gapY = 4,
    truncate = false,
}) => {
    const className = classNames('flex flex-col', containerClassName);

    const labelClassName = classNames(
        'font-body text-body-regular-xs text-neutral-300',
        truncate && 'truncate'
    );

    return (
        <div className={className} style={{ gap: gapY }}>
            <p className={labelClassName}>Stage: {name}</p>
            <div className="flex items-center" style={{ gap: gapX }}>
                <div className={progressBarClassName}>
                    <ProgressBar size="lg" progressPercentage={progress * 100} color="black" />
                </div>
                <p className="font-body-bold text-body-bold-xs text-neutral-500">
                    {parseFloat((progress * 5).toFixed(2))}/5
                </p>
            </div>
        </div>
    );
};

export default StageProgress;
